import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export default function CreateFileTemplatePage(_ref) {
  let {
    service,
    templateType,
    fileType
  } = _ref;
  return function TemplatePage(_ref2) {
    let {
      handleToaster,
      accountType
    } = _ref2;
    const [loading, setLoading] = useState(false);
    const [template, setTemplate] = service.useGet({
      loading
    });
    const {
      t
    } = useTranslation();
    const uploadTemplate = service.useCreate({
      loading
    });
    function uploadFileFormData(e) {
      uploadTemplate({
        formDataJson: {
          'file': e.target.files[0]
        }
      });
    }
    const DocumentsSection = _ref3 => {
      let {
        title,
        template,
        type
      } = _ref3;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: 12
      }, /*#__PURE__*/React.createElement("h5", null, title))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: 12,
        className: "d-flex justify-content-center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "btn btn-info btn-md me-2"
      }, loading ? /*#__PURE__*/React.createElement(Loader, null) : t('upload_template'), /*#__PURE__*/React.createElement("input", {
        style: {
          display: 'none'
        },
        type: "file",
        onChange: uploadFileFormData
      })), template && /*#__PURE__*/React.createElement("a", {
        href: template.download_link.url,
        download: `${title}.${fileType}`,
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement("label", {
        className: "btn btn-info btn-md"
      }, t('download_template'))))));
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MasterSidebar, {
      accountType: accountType
    }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement("h4", null, t(templateType))), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(DocumentsSection, {
      title: t(templateType),
      template: template
    }))));
  };
}